import { createSlice } from "@reduxjs/toolkit";

import {
  AccessLevel,
  type AuthStoreState,
  BackstageSortOptions,
  DashboardUserStatusOptions,
  Options,
  ThemeOptions,
} from "../../types";

const initialState: AuthStoreState = {
  accessLevel: AccessLevel.VIEWER,
  createdDate: new Date().toString(),
  updatedDate: new Date().toString(),
  authenticated: false,
  jwtToken: "",
  settings: {
    backstageRecents: Options.ENABLED,
    backstageSort: BackstageSortOptions.NAME,
    dashboardQueue: Options.ENABLED,
    dashboardSort: Options.DISABLED,
    dashboardUserFilter: Options.DISABLED,
    dashboardUserStatus: DashboardUserStatusOptions.ALL,
    id: null,
    theme: ThemeOptions.SYSTEM,
    tracking: Options.ENABLED,
    version: null,
  },
  firstname: "",
  lastname: "",
  pbxes: [],
  partner: null,
  email: "",
  id: null,
};

const { actions, reducer } = createSlice({
  name: "appBar",
  initialState,
  reducers: {
    setAuth(state, action) {
      return {
        ...action.payload,
        authenticated: true,
        jwtToken: state.jwtToken,
      };
    },
    setJwtToken(state, action) {
      state.jwtToken = action.payload;
    },
    setSettings(state, action) {
      state.settings = { ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase("root/clearAuthData", () => {
      return initialState;
    });
  },
});

export const { setAuth, setJwtToken, setSettings } = actions;

export default reducer;
